import * as types from "../Actions/Types";
import { IMapState } from "../Models/IMapState";

export interface ISessionReducerState {
  loadingLastSession: boolean;
  foundLastSession: boolean;
  lastSession: IMapState;
}

const defaultState: ISessionReducerState = {
    loadingLastSession: true,
    foundLastSession: true,
    lastSession: null,
};

export const session = (
    state: ISessionReducerState = { ...defaultState },
    action
): ISessionReducerState => {
    switch (action.type) {
        case types.SET_LOADING_LAST_SESSION: {
            return {
                ...state,
                loadingLastSession: action.data,
            };
        }

        case types.SET_FOUND_LAST_SESSION: {
            return {
                ...state,
                foundLastSession: action.data,
            };
        }

        case types.SET_SESSION: {
            return {
                ...state,
                lastSession: action.data,
            };
        }

        default:
            return state;
    }
};
